import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { WPSID } from 'app/_class/wpsid';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from 'app/_utils/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class FleetsService {

  constructor(private http: HttpClient, private cookieService: CookieService) { }

  async getFleets(idCliente: number, grupo = null){

    // Token es la cookie at (access token) de cognito. Necesario si se quiere consultar
    // los grupos de un cliente filtrados por los que tiene disponible el usuario.
    // El filtro solo aplica a usuarios supervisores y normales, mas no a administradores.    
    const at = await AuthService.getAt()
    
  
    let url = `${environment.endPoint}/ClientSite/api/GetClase`;

    if (idCliente > 0) {
      url += `?cliente=${idCliente}`;
    }

    if (grupo !== null) {
      if (idCliente > 0) {
        url += `&grupo=${grupo}`;
      } else{
        url += `?grupo=${grupo}`;
      }
    }

    let fleets: any[] = [];

    const headers = new HttpHeaders({
      'id-client': `${idCliente}`,
      'Authorization': `Bearer ${at}`
    });
    await this.http.get<any[]>(url, { headers, withCredentials: true})
    .toPromise()
    .then(data => {
      fleets = data;
    });

    return fleets;
  }
}
